

















import { Vue, Component, Prop } from "vue-property-decorator";
import { IUser } from "@/models/users";
import _ from "@/boot/lodash";

@Component
export default class UserBrandPermissions extends Vue {
  // Props

  @Prop({ required: true })
  public user!: IUser;

  // Computed

  public get brandPermissions() {
    return _.map(
      _.groupBy(this.user.user_brand_group, "brand_id"),
      permissions => {
        const brand = permissions[0]?.brand?.name;
        const roles = _.map(permissions, ({ group }) => group?.name);
        return this.$tc("_plurals.brand_roles", roles.length, {
          brand,
          role: roles.at(-1),
          roles: roles.slice(0, -1).join(", ")
        });
      }
    );
  }
}
